import React from 'react'
import './OurStory.css'
import Footer from './footer'
import Navbar from './Navbar'

export default function OurStory() {
  const image = "https://images.unsplash.com/photo-1524659679650-3bf1bace8aa2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"
  const uploadImage = "https://mdbcdn.b-cdn.net/img/new/fluid/nature/012.webp";
  return (
      <>
              <div
                  className="bg-image"
                  style={{
    backgroundColor: "none",
    backgroundImage: `url(${uploadImage})`,
    height: "100vh"
  }}
              >
                  <div className="maskDiv col-md-6">
                      <div className="d-flex flex-column justify-content-center align-items-center mask">
                          <h1 className="text-white mb-0">Our Story</h1>
                          <p className='mb-0 text-center my-3 mx-3'
                          style={{width: "80%"}}>I'm a paragraph. Click here to add 
                            your own text and edit me. It’s easy. 
                            Just click “Edit Text” or double click 
                            me to add your own content and make 
                            changes to the font. I’m a great place 
                             for you to tell a story and let your 
                             users know a little more about you.</p>
                      </div>
                  </div>
              </div>
      </>
  )
}
